/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type ExternalAuthInput = {
    token: string;
    tenantId: string;
    appId?: string | null | undefined;
};
export type HandleExternalAuthMutationVariables = {
    authInput: ExternalAuthInput;
};
export type HandleExternalAuthMutationResponse = {
    readonly handleExternalAuth: {
        readonly status: number;
        readonly message: string;
        readonly data: {
            readonly firstName: string | null;
            readonly lastName: string | null;
            readonly userId: string | null;
            readonly userName: string | null;
            readonly email: unknown | null;
        } | null;
    };
};
export type HandleExternalAuthMutation = {
    readonly response: HandleExternalAuthMutationResponse;
    readonly variables: HandleExternalAuthMutationVariables;
};



/*
mutation HandleExternalAuthMutation(
  $authInput: ExternalAuthInput!
) {
  handleExternalAuth(authInput: $authInput) {
    status
    message
    data {
      firstName
      lastName
      userId
      userName
      email
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "authInput"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "authInput",
        "variableName": "authInput"
      }
    ],
    "concreteType": "ExternalAuthResponse",
    "kind": "LinkedField",
    "name": "handleExternalAuth",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AuthResponse",
        "kind": "LinkedField",
        "name": "data",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HandleExternalAuthMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HandleExternalAuthMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5a33cd3c3db4118abf79f8e2acacdd44",
    "id": null,
    "metadata": {},
    "name": "HandleExternalAuthMutation",
    "operationKind": "mutation",
    "text": "mutation HandleExternalAuthMutation(\n  $authInput: ExternalAuthInput!\n) {\n  handleExternalAuth(authInput: $authInput) {\n    status\n    message\n    data {\n      firstName\n      lastName\n      userId\n      userName\n      email\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '020ebbb4b346c8e6c5f30da4c8f22966';
export default node;
